import { FloatInputField, FloatInputFieldProps } from '@brighte/form-components';
import { Text } from '@spark-web/text';
import { InputAdornment } from '@spark-web/text-input';

type RepaymentInput = FloatInputFieldProps & {
  period: 'monthly' | 'yearly';
  additionalLabel?: string;
  endLabel?: string;
};

function RepaymentInput({ period, additionalLabel, endLabel, ...props }: RepaymentInput) {
  const label = endLabel ?? (period === 'monthly' ? `monthly ${additionalLabel ?? ''}`.trim() : 'yearly');

  return (
    <FloatInputField {...props}>
      <InputAdornment placement="start">
        <Text>$</Text>
      </InputAdornment>
      <InputAdornment placement="end">
        <Text>{label}</Text>
      </InputAdornment>
    </FloatInputField>
  );
}

export { RepaymentInput };
